(() => {
  'use strict';

  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Notice strip: hide on scroll past 40px, show again near top ──
  const noticeStrip = $('.ss-notice-strip');
  if (noticeStrip) {
    const setNoticeHidden = (hide) => {
      noticeStrip.setAttribute('data-hidden', hide ? 'true' : 'false');
      document.documentElement.style.setProperty('--notice-h', hide ? '0px' : '36px');
    };
    let hidden = false;
    const onScroll = () => {
      const y = window.scrollY || 0;
      if (y > 40 && !hidden) { hidden = true; setNoticeHidden(true); }
      else if (y <= 4 && hidden) { hidden = false; setNoticeHidden(false); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── SHOP mega panel ──
  const fhWrap = $('#ss-fh-wrap');
  const shopTrigger = $('#ss-shop-trigger');
  const shopWrap = $('#ss-shop-wrap');
  const searchBar = $('#ss-search-bar');
  const searchOverlay = $('#ss-search-overlay');
  const closeShop = () => { if (shopWrap) { shopWrap.classList.remove('is-open'); shopWrap.setAttribute('aria-hidden', 'true'); } };
  const closeSearch = () => {
    if (searchBar) searchBar.classList.remove('is-open');
    if (searchOverlay) searchOverlay.classList.remove('is-visible');
  };
  if (fhWrap && shopTrigger && shopWrap) {
    const openShop = () => { closeSearch(); shopWrap.classList.add('is-open'); shopWrap.setAttribute('aria-hidden', 'false'); };
    shopTrigger.addEventListener('mouseenter', openShop);
    fhWrap.addEventListener('mouseleave', closeShop);
    $$('#ss-nav .ss-nav-link').forEach((el) => {
      if (!shopTrigger.contains(el)) el.addEventListener('mouseenter', closeShop);
    });
  }

  // ── Search bar toggle ──
  const searchToggle = $('#ss-search-toggle');
  const searchClose = $('#ss-search-close');
  if (searchBar && searchToggle) {
    searchToggle.addEventListener('click', () => {
      closeShop();
      const open = searchBar.classList.toggle('is-open');
      if (searchOverlay) searchOverlay.classList.toggle('is-visible', open);
      if (open) {
        setTimeout(() => {
          const input = searchBar.querySelector('input');
          if (input) input.focus();
        }, 60);
      }
    });
  }
  if (searchClose && searchBar) {
    searchClose.addEventListener('click', closeSearch);
  }
  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  // ── Hamburger / mobile drawer ──
  const hamburger = $('#ss-hamburger');
  const drawer = $('#ss-drawer');
  const hamburgerIcon = $('#ss-hamburger-icon');

  const buildLine = (x1, y1, x2, y2) => {
    const line = document.createElementNS(SVG_NS, 'line');
    line.setAttribute('x1', x1);
    line.setAttribute('y1', y1);
    line.setAttribute('x2', x2);
    line.setAttribute('y2', y2);
    return line;
  };
  const setHamburgerOpen = (open) => {
    if (!hamburgerIcon) return;
    while (hamburgerIcon.firstChild) hamburgerIcon.removeChild(hamburgerIcon.firstChild);
    const lines = open
      ? [[18, 6, 6, 18], [6, 6, 18, 18]]
      : [[3, 7, 21, 7], [3, 12, 21, 12], [3, 17, 21, 17]];
    lines.forEach(([x1, y1, x2, y2]) => hamburgerIcon.appendChild(buildLine(x1, y1, x2, y2)));
  };
  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      setHamburgerOpen(open);
    });
    $$('.ss-drawer-link').forEach((link) => {
      link.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        setHamburgerOpen(false);
      });
    });
  }

  // ── Weekly stamp: live timestamp updated every 30s ──
  const stamps = $$('[data-weekly-stamp]');
  if (stamps.length > 0) {
    const renderStamp = () => {
      const now = new Date();
      const y = now.getFullYear();
      const mo = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      const hh = String(now.getHours()).padStart(2, '0');
      const mm = String(now.getMinutes()).padStart(2, '0');
      const text = `${y}.${mo}.${d}  ·  ${hh}:${mm}`;
      stamps.forEach((s) => { s.textContent = text; });
    };
    renderStamp();
    setInterval(renderStamp, 30 * 1000);
  }

  // ── TransmissionFeed: 3 rows, random pool, prepend on cadence ──
  const ROWS = 3;
  const feedRoot = $('#ss-feed-rows');

  const FALLBACK_POOL = [
    { ts: 'T·1961', tag: 'GAGARIN',  msg: 'The Earth is blue. How wonderful. It is amazing.' },
    { ts: 'T·1969', tag: 'ALDRIN',   msg: 'Magnificent desolation.' },
    { ts: 'T·1980', tag: 'SAGAN',    msg: 'We are made of star-stuff.' },
    { ts: 'T·1979', tag: 'ADAMS',    msg: 'Space is big. Really, really big.' },
    { ts: 'T·1962', tag: 'CLARKE',   msg: 'Any sufficiently advanced technology is indistinguishable from magic.' },
    { ts: 'T·1633', tag: 'GALILEI',  msg: 'Eppur si muove — and yet it moves.' },
    { ts: 'T·1610', tag: 'KEPLER',   msg: 'Where there is matter, there is geometry.' },
    { ts: 'T·1923', tag: 'TSIOLKOV', msg: 'Earth is the cradle of humanity, but one cannot live in a cradle forever.' },
    { ts: 'T·1957', tag: 'SPUTNIK',  msg: 'Beep · beep · beep — first signal from orbit.' },
    { ts: 'T·1971', tag: 'SHEPARD',  msg: 'Houston, the eagle has landed. Looking up — and onward.' },
  ];

  const domPool = feedRoot ? Array.from(feedRoot.children).map((row) => {
    const m = row.querySelector('.ss-feed-row__msg');
    const arrow = m && m.querySelector('.ss-feed-row__arrow');
    return {
      ts:  row.querySelector('.ss-feed-row__ts')?.textContent?.trim()  || '',
      tag: row.querySelector('.ss-feed-row__tag')?.textContent?.trim() || '',
      msg: m ? (m.textContent || '').replace(arrow ? arrow.textContent : '', '').trim() : '',
    };
  }).filter((q) => q.tag) : [];

  const POOL = domPool.length ? domPool : FALLBACK_POOL;

  const buildFeedRow = (q, isNew) => {
    const row = document.createElement('div');
    row.className = 'ss-feed-row' + (isNew ? ' is-new' : '');

    const ts = document.createElement('span');
    ts.className = 'ss-feed-row__ts';
    ts.textContent = q.ts;

    const tag = document.createElement('span');
    tag.className = 'ss-feed-row__tag';
    tag.textContent = q.tag;

    const msg = document.createElement('span');
    msg.className = 'ss-feed-row__msg';
    const arrow = document.createElement('span');
    arrow.className = 'ss-feed-row__arrow';
    arrow.textContent = '→';
    msg.appendChild(arrow);
    msg.appendChild(document.createTextNode(q.msg));

    row.appendChild(ts);
    row.appendChild(tag);
    row.appendChild(msg);
    return row;
  };

  const seedFeed = () => {
    if (!feedRoot) return;
    const shuffled = [...POOL].sort(() => Math.random() - 0.5).slice(0, ROWS);
    while (feedRoot.firstChild) feedRoot.removeChild(feedRoot.firstChild);
    shuffled.forEach((q) => feedRoot.appendChild(buildFeedRow(q, false)));
  };

  if (feedRoot && !prefersReducedMotion) {
    seedFeed();
    const tick = () => {
      const visibleMsgs = new Set(
        Array.from(feedRoot.children).map((el) => {
          const m = el.querySelector('.ss-feed-row__msg');
          const arrow = m && m.querySelector('.ss-feed-row__arrow');
          if (!m) return '';
          return (m.textContent || '').replace(arrow ? arrow.textContent : '', '').trim();
        })
      );
      const candidates = POOL.filter((q) => !visibleMsgs.has(q.msg));
      const pick = (candidates.length ? candidates : POOL)[Math.floor(Math.random() * (candidates.length || POOL.length))];
      const newRow = buildFeedRow(pick, true);
      feedRoot.insertBefore(newRow, feedRoot.firstChild);
      while (feedRoot.children.length > ROWS) feedRoot.removeChild(feedRoot.lastChild);
      Array.from(feedRoot.children).forEach((el, i) => {
        if (i !== 0) el.classList.remove('is-new');
      });
      const nextDelay = 3200 + Math.random() * 4200;
      setTimeout(tick, nextDelay);
    };
    setTimeout(tick, 2400);
  }

  // ── Fade-in observer (.ss-fade → .ss-fade.in on intersect) ──
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    $$('.ss-fade').forEach((el) => io.observe(el));
  }

  // ── Section title char-by-char animation ──
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    $$('.ss-section-bar__title').forEach((h2) => {
      const text = h2.textContent;
      h2.setAttribute('aria-label', text);
      h2.textContent = '';
      [...text].forEach((ch, i) => {
        const span = document.createElement('span');
        span.className = 'ss-title-char';
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--ci', i);
        span.textContent = ch === ' ' ? ' ' : ch;
        h2.appendChild(span);
      });
    });
    const titleIo = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          titleIo.unobserve(en.target);
        }
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -6% 0px' });
    $$('.ss-section-bar__title').forEach((el) => titleIo.observe(el));
  }

  // ── Weekly best: JS-driven marquee with drag/touch scroll ──
  const marqueeHost = $('.ss-marquee-host');
  const marqueeTrack = $('#ss-weekly-track');
  if (marqueeHost && marqueeTrack) {
    let offset = 0;
    let isPaused = false;
    let isDragging = false;
    let didDrag = false;
    let dragStartX = 0;
    let dragStartOffset = 0;
    const SPEED = 0.5;

    const getHalf = () => marqueeTrack.scrollWidth / 2;

    const loop = () => {
      if (!isPaused) {
        offset += SPEED;
        const half = getHalf();
        if (half > 0 && offset >= half) offset -= half;
        marqueeTrack.style.transform = `translateX(-${offset}px)`;
      }
      requestAnimationFrame(loop);
    };
    marqueeTrack.style.transform = 'translateX(0)';
    requestAnimationFrame(loop);

    marqueeHost.addEventListener('mousedown', (e) => {
      isDragging = true;
      didDrag = false;
      isPaused = true;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      marqueeHost.classList.add('is-dragging');
      e.preventDefault();
    });
    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      isPaused = false;
      marqueeHost.classList.remove('is-dragging');
    });
    marqueeHost.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = dragStartX - e.clientX;
      if (Math.abs(delta) > 5) didDrag = true;
      const half = getHalf();
      if (half > 0) offset = ((dragStartOffset + delta) % half + half) % half;
      marqueeTrack.style.transform = `translateX(-${offset}px)`;
    });
    marqueeHost.addEventListener('click', (e) => {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);

    marqueeHost.addEventListener('touchstart', (e) => {
      isPaused = true;
      dragStartX = e.touches[0].clientX;
      dragStartOffset = offset;
    }, { passive: true });
    marqueeHost.addEventListener('touchend', () => { isPaused = false; }, { passive: true });
    marqueeHost.addEventListener('touchmove', (e) => {
      const delta = dragStartX - e.touches[0].clientX;
      const half = getHalf();
      if (half > 0) offset = ((dragStartOffset + delta) % half + half) % half;
      marqueeTrack.style.transform = `translateX(-${offset}px)`;
    }, { passive: true });
  }
})();
